import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { routes } from '../routes';

import { PageWrapper } from './components';
import RouteResolver from './components/RouteResolver';

function Router() {
    return (
        <PageWrapper>
            <Routes>
                {routes.map((route) => (
                    <Route
                        element={<RouteResolver route={route} />}
                        key={route.path}
                        path={route.path}
                    />
                ))}
            </Routes>
        </PageWrapper>
    );
}

export default Router;
